import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../../contexts/ContextProvider";
import { ShowTableBeli } from "../../../../components/ShowTable";
import { FetchErrorHandling } from "../../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../../components";
import { Colors } from "../../../../constants/styles";
import { Form } from "react-bootstrap";
import {
  Box,
  Typography,
  Divider,
  Pagination,
  Button,
  Chip,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";

const TampilDaftarBeli = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const navigate = useNavigate();
  const [isFetchError, setIsFetchError] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [value, setValue] = useState("No. Nota");
  const [belisPagination, setBelisPagination] = useState([]);
  const kode = null;

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    getBelisPagination();
  }, [page, searchTerm, value]);

  const getBelisPagination = async () => {
    setLoading(true);
    try {
      let tempUrlSwitch;
      switch (value) {
        case "No. Nota":
          tempUrlSwitch = "belisPagination";
          break;
        case "Nama Supplier":
          tempUrlSwitch = "belisOrderBySupplierPagination";
          break;
        case "Lunas":
          tempUrlSwitch = "belisLunasPagination";
          break;
        case "Belum Lunas":
          tempUrlSwitch = "belisBelumLunasPagination";
          break;
        case "Jatuh Tempo":
          tempUrlSwitch = "belisJatuhTempoPagination";
          break;
      }

      const response = await axios.post(
        `${tempUrl}/${tempUrlSwitch}?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      setQuery(searchTerm);
      setBelisPagination(response.data.belis);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Box>
      <Typography color="#757575">Pembelian</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Daftar Beli
      </Typography>
      <FormControl sx={{ marginTop: 1 }}>
        <FormLabel id="demo-controlled-radio-buttons-group">Sortir</FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          defaultValue="No. Nota"
          value={value}
          onChange={(event) => setValue(event.target.value)}
        >
          <FormControlLabel
            value="No. Nota"
            control={<Radio />}
            label="No. Nota"
          />
          <FormControlLabel
            value="Nama Supplier"
            control={<Radio />}
            label="Nama Supplier"
          />
          <FormControlLabel value="Lunas" control={<Radio />} label="Lunas" />
          <FormControlLabel
            value="Belum Lunas"
            control={<Radio />}
            label="Belum Lunas"
          />
          <FormControlLabel
            value="Jatuh Tempo"
            control={<Radio />}
            label="Jatuh Tempo"
          />
        </RadioGroup>
      </FormControl>
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={"/"}
          kode={kode}
          addLink={`/daftarBeli/beli/tambahBeli`}
          editLink={`/`}
          deleteUser={"/"}
        />
      </Box>
      <Divider sx={dividerStyle} />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Chip
        label="Sudah Lunas"
        sx={{
          backgroundColor: Colors.green400,
        }}
      />
      <Chip
        label="Jatuh Tempo"
        sx={{
          backgroundColor: Colors.red400,
        }}
      />
      <Box sx={tableContainer}>
        <ShowTableBeli currentPosts={belisPagination} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Box>
  );
};

export default TampilDaftarBeli;

const container = {
  p: 4,
};

const subTitleText = {
  fontWeight: "900",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const dividerStyle = {
  pt: 4,
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
